module.exports = __webpack_public_path__ + "img/14.b105cf5b.png";